import cloudy from '../../../core/assets/images/icons/weather/cloudy.svg'
import fog from '../../../core/assets/images/icons/weather/fog.svg'
import hail from '../../../core/assets/images/icons/weather/hail.svg'
import lightRain from '../../../core/assets/images/icons/weather/light-rain.svg'
import partlyCloudy from '../../../core/assets/images/icons/weather/partly-cloudy.svg'
import rain from '../../../core/assets/images/icons/weather/rain.svg'
import snow from '../../../core/assets/images/icons/weather/snow.svg'
import storm from '../../../core/assets/images/icons/weather/storm.svg'
import sunny from '../../../core/assets/images/icons/weather/sunny.svg'
import { WEATHER_CODES } from '../../../core/api/weather/weather-code'
import { useFormatNumber } from 'core/hooks/useFormatNumber'

type WeatherCode = (typeof WEATHER_CODES)[number]

type WeatherProps = {
  weatherCode?: WeatherCode
  iconPlaceholder?: string
  temperatureMin?: number
  temperatureMax?: number
}

const ICON_BY_WEATHER_CODE: Record<WeatherCode, string | null> = {
  CLOUDY: cloudy,
  FOG: fog,
  ICE: hail,
  LIGHT_RAIN: lightRain,
  PARTLY_CLOUDY: partlyCloudy,
  RAIN: rain,
  SNOW: snow,
  STORM: storm,
  SUNNY: sunny,
  UNKNOWN: null
}

const mapCodeToIcon = (code: WeatherCode) => ICON_BY_WEATHER_CODE[code]

const Weather = ({ weatherCode, iconPlaceholder, temperatureMin, temperatureMax }: WeatherProps) => {
  const weatherCodeIcon = mapCodeToIcon(weatherCode)

  const formatNumber = useFormatNumber()
  const formatTemperature = (temperature: number) => `${formatNumber(temperature, '--', { maximumFractionDigits: 0 })}°`

  return (
    <div className="mg-weather" data-testid="weather">
      {weatherCodeIcon && <img src={weatherCodeIcon} alt="" aria-hidden className="mg-weather-icon" />}
      {!weatherCodeIcon && iconPlaceholder && (
        <div className="mg-weather-icon mg-weather-icon-unavailable">{iconPlaceholder}</div>
      )}

      {temperatureMax != null && (
        <div className="mg-weather-temperature-max vp-body-l">{formatTemperature(temperatureMax)}</div>
      )}
      {temperatureMin != null && (
        <div className="mg-weather-temperature-min vp-body-l">{formatTemperature(temperatureMin)}</div>
      )}
    </div>
  )
}

export default Weather
